module.exports = __webpack_public_path__ + "img/pin-gray.8d841560.svg";